module.exports = __webpack_public_path__ + "img/custom-attack.2374c490.png";